/** FORM INTERFACES  */

import { AbstractControl, FormGroup } from '@angular/forms';
import { PaymentDataInterface } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-payment.interface';

/** JSON values */
interface BillingAddress {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
}

export interface CreditCardFormControlsAsJson {
  ccType: string;
  ccNumEnc: string;
  ccExpDtMonth: string;
  ccExpDtYear: string;
  name: string;
  billingAddress: BillingAddress;
}

export interface BankFormControlsAsJson {
  routingNumber: string;
  accountNumber: string;
  primaryNameOnAccount: string;
  billingAddress: BillingAddress;
}
/** END FORM INTERFACES */

export enum ON_EXCHANGE_PAYMENT_METHODS {
  CREDIT_CARD = 'credit',
  BANK_ACCOUNT = 'ach',
  PAY_BY_PHONE = 'pbp',
  BILL_ME_LATER = 'BML'
}
export interface MarketplacePaymentOptionsControlsAsJson {
  selectedPaymentType: ON_EXCHANGE_PAYMENT_METHODS;
}

export interface OnExchangeEnrollmentPaymentFormStateStructure {
  marketplacePaymentOptions: MarketplacePaymentOptionsControlsAsJson;
  marketplacePaymentInfo: {
    [ON_EXCHANGE_PAYMENT_METHODS.BANK_ACCOUNT]: BankFormControlsAsJson;
    [ON_EXCHANGE_PAYMENT_METHODS.CREDIT_CARD]: CreditCardFormControlsAsJson;
  };
  marketplacePaymentReview: unknown;
  marketplacePaymentConfirmation: unknown;
  paymentManagerServiceData: PaymentDataInterface;
  paymentManagerServiceConfirmationNum: string;
}
